module.exports = __webpack_public_path__ + "de77a722/img/note-edit-icon.acae1669.svg";